<template>
  <el-popover
    width="240"
    placement="right"
    :disabled="disabled"
    trigger="hover"
  >
    <div class="popover">
      <div
        class="menu-item"
        @click="itemClick(menu)"
        :key="menu.id"
        v-for="menu in menuList"
        v-text="menu.text"
      ></div>
    </div>
    <div slot="reference">
      <slot></slot>
    </div>
  </el-popover>
</template>

<style lang="less" scoped>
@import "../../assets/style/theme.less";

.popover {
  padding: 5px 0;

  .menu-item {
    height: 60px;
    margin-bottom: 10px;
    display: flex;
    align-items: center;
    padding: 0 20px;
    font-size: 16px;
    font-weight: 400;
    cursor: pointer;
    white-space: pre-line;
    &:hover {
      background: rgba(230, 43, 85, 0.15);
    }
  }
}
</style>
<script>
export default {
  name: "LayoutMenuItemComponent",
  props: {
    disabled: {
      // 是否禁用该逻辑，比如菜单展开时候就禁用
      type: Boolean,
      default: false,
    },
    menuList: {
      type: Array, // 显示的菜单项
      required: true,
    },
  },
  methods: {
    itemClick(item) {
      this.$emit("itemClick", item);
      this.$bus.$emit("switchMenu", item);
    },
  },
};
</script>
